import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="max-w-prose mx-auto px-8 py-32 text-center" data-testid="notfound-root">
      <span className="font-mono text-[11px] tracking-meta uppercase text-vermilion mb-2 inline-block">
        {t('notFound.eyebrow')}
      </span>
      <h1 className="font-serif text-4xl font-medium mb-3">{t('notFound.title')}</h1>
      <p className="text-base text-ink-2 mb-8">{t('notFound.body')}</p>
      <Link to="/" className="btn btn-primary">{t('notFound.cta')}</Link>
    </div>
  );
}
